import { Fragment } from "react";
import Card from "../UI/Card";
import classes from "./Photos.module.css";
import ProductsContext from "../../store/products-context";
import { useContext, useState } from "react";
import Modal from "../UI/Modal";
import galleryHelpers from "../../store/gallery-helper";

import prod1 from "../../assets/secondProject/products/Film_Anna Fąfara Iskra.mov";
import prod2 from "../../assets/secondProject/products/Konspekt 1.pdf";
import prod3 from "../../assets/secondProject/products/Konspekt 2.pdf";
import prod4 from "../../assets/secondProject/products/Konspekt 3.pdf";
import prod5 from "../../assets/secondProject/products/Konspekt 4.pdf";
import prod6 from "../../assets/secondProject/products/Konspekt 5.pdf";
import prod7 from "../../assets/secondProject/products/Power_AFąfaraIskra.pdf";
import prod8 from "../../assets/secondProject/products/Power_Magorzata Szmigiel_Drzew o genealogiczne zrobione PDF.pdf";
import prod9 from "../../assets/secondProject/products/Power_Magorzata Szmigiel_Mia sta woskiego renesansu PDF.pdf";
import prod10 from "../../assets/secondProject/products/Power_Małgorzata Szmigeil_WAKACJE.pdf";
import prod11 from "../../assets/secondProject/products/Power_Małgorzata Szmigiel_ WARSZAWA.pdf";
import prod12 from "../../assets/secondProject/products/Power_Małgorzata Szmigiel_rok liturgiczny.pdf";
import prod13 from "../../assets/secondProject/products/Power_Małgorzata Szmigiel_Segregacja śmieci.pdf";
import prod14 from "../../assets/secondProject/products/Power_MKozłowska.pdf";

const prods = [
  [prod1, "Film"],
  [
    prod2,
    "Konspekt zajęć z edukacji umysłowej z elementami języka angielskiego (4-5 latki)",
  ],
  [
    prod3,
    "Konspekt z zajęć z edukacji umysłowej z elementami języka angielskiego (5-6 latki)",
  ],
  [
    prod4,
    "Konspekt z zajęć z edukacji przyrodniczej z elementami języka angielskiego (4-5 latki)",
  ],
  [
    prod5,
    "Konspekt z zajęć z edukacji przyrodniczej z elementami języka angielskiego (5-6 latki)",
  ],
  [
    prod6,
    "Konspekt zajęć z edukacji umysłowej z elementami języka angielskiego (3-4 latki)",
  ],
  [
    prod7,
    "KONSPEKT ZAJĘĆ Z EDUKACJI MATEMATYCZNEJ Z ELEMENTAMI JĘZYKA ANGIELSKIEGO",
  ],
  [prod8, "KONSPEKT ZAJĘĆ Z HISTORII Z ELEMENTAMI JĘZYKA ANGIELSKIEGO"],
  [
    prod9,
    "KONSPEKT DO LEKCJI HISTORII Z ELEMENTAMI JĘZYKA ANGIELSKIEGO Klasa VI",
  ],
  [
    prod10,
    "KONSPEKT ZAJĘĆ Z GODZINY WYCHOWAWCZEJ Z ELEMENTAMI JĘZYKA ANGIELSKIEGO",
  ],
  [
    prod11,
    "KONSPEKT ZAJĘĆ Z HISTORII Z ELEMENTAMI JĘZYKA ANGIELSKIEGO Klasa VIII",
  ],
  [prod12, "KONSPEKT ZAJĘĆ Z RELIGII Z ELEMENTAMI JĘZYKA ANGIELSKIEGO"],
  [
    prod13,
    "KONSPEKT ZAJĘĆ Z ZAJĘĆ Z WYCHOWAWCĄ Z ELEMENTAMI JĘZYKA ANGIELSKIEGO",
  ],
  [
    prod14,
    "KONSPEKT ZAJĘĆ WYCHOWANIA FIZYCZNEGO I EDUKACJI ZDROWOTNEJ Z ELEMENTAMI JĘZYKA ANGIELSKIEGO",
  ],
];

let itemList = [];

prods.forEach((elem) => {
  itemList.push(
    <a className={classes.toDownload} href={elem[0]} download>
      {elem[1]} <br></br>
      <br></br>
    </a>
  );
});

const ProductsComponent = (props) => {
  const ctx = useContext(ProductsContext);
  const [isZoomedIn, setIsZoomedIn] = useState(false);
  const [currentPhoto, setCurrentPhoto] = useState("");

  const content = ctx.photos.map((photo) => (
    <img
      key={photo}
      onClick={() =>
        galleryHelpers.zoomInHandler(photo, setIsZoomedIn, setCurrentPhoto)
      }
      src={photo}
      alt=""
    />
  ));

  return (
    <Fragment>
      <Card>
        <h1>Produkty</h1>
        <p className={classes.text}>
          Wszystkie założone w aplikacji cele projektu zostały zrealizowane.
          Wynikiem szkoleń i job shadowing/produktem materialnym są konspekty
          lekcyjne z zakresu przedmiotów ogólnokształcących z zastosowaniem
          elementów języka angielskiego.
        </p>
        <h1>Produkty do pobrania</h1>
        {itemList}
      </Card>
    </Fragment>
  );
};

export default ProductsComponent;
